import { LngLatBounds } from '@yandex/ymaps3-types';

export function getBounds(coordinates: number[][]): LngLatBounds {
  let minLng = Infinity,
    minLat = Infinity,
    maxLng = -Infinity,
    maxLat = -Infinity;

  for (const coords of coordinates) {
    const lng = coords[0];
    const lat = coords[1];

    if (lng < minLng) minLng = lng;
    if (lng > maxLng) maxLng = lng;
    if (lat < minLat) minLat = lat;
    if (lat > maxLat) maxLat = lat;
  }

  return [
    [minLng, minLat],
    [maxLng, maxLat]
  ] as LngLatBounds;
}
